import { Grid, Typography, Button, Box } from "@mui/material";
import CourseCard from "./CourseCard";
import CountrySelect from "./CountrySelect";
import Filters from "./FiltersDropdown";
import { useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import NoCoursesFound from "../../pages/courses/NoCoursesFound";
import { filterCoursesApi } from "../../api/coursesApi";
import CustomPagination from "../../components/pagination/CustomPagination";
import SAP_CourseCard from "./CourseCard";

const courseEndPoint = process.env.REACT_APP_API_SAP;

export default function CoursesGrid() {
  const initialCountry = localStorage.getItem("targetCountryId");
  const initialBroadFiled = localStorage.getItem("broadFieldId");
  const initialNarrowField = localStorage.getItem("narrowFieldId");
  const [courses, setCourses] = useState([]);
  const [countries, setCountries] = useState([Number(initialCountry) || null]);
  const [broadFields, setBroadFields] = useState([
    Number(initialBroadFiled) || null,
  ]);
  const [narrowFields, setNarrowFields] = useState([
    Number(initialNarrowField) || null,
  ]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    nextPage: null,
    prevPage: null,
  });


  useEffect(() => {
    fetchAllCourses(1);
  }, []);

  const fetchAllCourses = async (page = 1) => {
    try {
      setLoading(true);

      const url = `${courseEndPoint}get-courses-filters?page=${page}`;

      const payload = {
        country_id: countries || [],
        broad_field_id: broadFields || [],
        narrow_field_id: narrowFields || [],
      };

      const response = await filterCoursesApi({ url, payload });
      const data = response?.data;

      setCourses(data?.data || []);

      setPagination({
        currentPage: data?.pagination?.currentPage || 1,
        totalPages:
          data?.pagination?.totalPages ||
          (data?.pagination?.nextPage
            ? data.pagination.currentPage + 1
            : data.pagination.currentPage),
        nextPage: data?.pagination?.nextPage
          ? Number(new URL(data.pagination.nextPage).searchParams.get("page"))
          : null,
        prevPage: data?.pagination?.prevPage
          ? Number(new URL(data.pagination.prevPage).searchParams.get("page"))
          : null,
        totalItems: data?.pagination?.totalItems || 0,
      });
    } catch (err) {
      console.error("Error fetching courses:", err);
    } finally {
      setLoading(false);
    }
  };

  const totalCount = pagination.totalPages * pagination.totalItems;

  return (
    <Grid container direction="column">
      {/* Header Row */}
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 1 }}
      >
        <Grid item display="flex" alignItems="center" gap={1}>
          <Typography
            className="font-inter"
            fontWeight="700"
            color="#572575"
            fontSize="26px"
          >
            Courses
          </Typography>

          <Box
            px={1.5}
            py={0.3}
            borderRadius="20px"
            bgcolor="#EFE7F5"
            color="#572575"
            fontWeight="600"
            fontSize="14px"
          >
            {totalCount}
          </Box>
        </Grid>

        <Grid item>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <CountrySelect
                onChange={(ids) => setCountries(ids)}
                onApply={() => fetchAllCourses(1)}
              />
            </Grid>
            <Grid item>
              <Filters
                onData={setCourses}
                selectedCountries={countries}
                onApply={() => fetchAllCourses(1)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Courses Grid */}
      {loading ? (
        <Loader />
      ) : (
        <Grid container spacing={2}>
          {courses.length > 0 ? (
            <>
              {courses.map((course, idx) => (
                <Grid item xs={12} sm={6} md={4} key={course.id || idx}>
                  <SAP_CourseCard course={course} />
                </Grid>
              ))}

              {/* Pagination */}
              <Grid item xs={12}>
                <CustomPagination
                  pagination={pagination}
                  onPageChange={(page) => fetchAllCourses(page)}
                />
              </Grid>
            </>
          ) : (
            <Grid item xs={12} mt={4}>
              <NoCoursesFound />
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  );
}
